/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'n_close-dialog': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path id="close-dialog-path" d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"/>'
  }
}) 